import {Link} from 'react-router-dom'
import {BRAND, WHY} from './site'
import {Container, PageHero} from './ui'
import {useLightbox} from './Lightbox'

const ABOUT_PHOTOS = [
  {src: '/images/community.webp', title: 'Resident lounge'},
  {src: '/images/lounge.webp', title: 'Lounge & dining'},
  {src: '/images/exterior.webp', title: 'The building'},
]

const AboutPage = () => {
  const {open} = useLightbox()
  return (
    <div>
      <PageHero title='About Crosscheck CrashPad' sub='Crew housing in San Francisco, built by people who understand the lifestyle.' />

      <section style={{padding: '0'}}>
        <img src='/images/community.webp' alt='Resident lounge' onClick={() => open(ABOUT_PHOTOS, 0)} style={{width: '100%', height: 'clamp(220px, 32vw, 420px)', objectFit: 'cover', display: 'block', cursor: 'zoom-in'}} />
      </section>

      <section style={{padding: '64px 0'}}>
        <Container>
          <div className='row g-5 align-items-center'>
            <div className='col-12 col-lg-7'>
              <div style={{color: BRAND.green, fontWeight: 700, fontSize: 13, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 12}}>Our story</div>
              <p style={{fontSize: 20, lineHeight: 1.7, color: BRAND.ink, fontWeight: 600, margin: '0 0 20px'}}>
                Crosscheck CrashPad provides clean, convenient, and professionally managed shared accommodations
                designed specifically for pilots, flight attendants, and other aviation professionals.
              </p>
              <p style={{fontSize: 16, lineHeight: 1.8, color: BRAND.muted, margin: '0 0 18px'}}>
                Created by a fellow aviation professional who understands reserve schedules, commuting, delays, and the
                need for dependable rest between assignments, Crosscheck offers more than a place to sleep. It provides
                a secure and respectful crew community in a convenient San Francisco location.
              </p>
              <p style={{fontSize: 16, lineHeight: 1.8, color: BRAND.muted, margin: '0 0 18px'}}>
                Our goal is to make the crashpad experience simple. Verified renters can review live bed availability,
                reserve a bed, receive private building information, access transportation instructions, submit cleaning
                or maintenance requests, and manage their stay through one renter portal.
              </p>
              <p style={{fontSize: 16, lineHeight: 1.8, color: BRAND.muted, margin: 0}}>
                Crosscheck CrashPad is built around the needs of aviation professionals: flexible access, reliable
                communication, a comfortable place to rest, and convenient transportation to and from SFO.
              </p>
            </div>
            <div className='col-12 col-lg-5'>
              <div className='ccp-lift ccp-zoom' onClick={() => open(ABOUT_PHOTOS, 1)} style={{position: 'relative', borderRadius: 18, overflow: 'hidden', aspectRatio: '4 / 3', boxShadow: '0 14px 36px rgba(27,27,41,0.12)', cursor: 'zoom-in'}}>
                <img src='/images/lounge.webp' alt='Lounge & dining' style={{width: '100%', height: '100%', objectFit: 'cover', display: 'block'}} />
              </div>
            </div>
          </div>
        </Container>
      </section>

      <section style={{padding: '8px 0 72px', background: BRAND.soft}}>
        <Container style={{paddingTop: 56, paddingBottom: 8}}>
          <h2 style={{fontSize: 28, fontWeight: 800, color: BRAND.ink, textAlign: 'center', margin: '0 0 36px'}}>What sets us apart</h2>
          <div className='row g-4'>
            {WHY.map((w) => (
              <div className='col-12 col-md-4' key={w.title}>
                <div className='ccp-lift' style={{background: '#fff', border: '1px solid #eef0f4', borderRadius: 18, padding: '30px 26px', height: '100%', boxShadow: '0 6px 18px rgba(27,27,41,0.04)'}}>
                  <div style={{width: 56, height: 56, borderRadius: 16, background: 'linear-gradient(135deg, rgba(3,149,64,0.12), rgba(3,149,64,0.04))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, marginBottom: 18}}>{w.icon}</div>
                  <h3 style={{fontSize: 19, fontWeight: 700, color: BRAND.ink, margin: '0 0 8px'}}>{w.title}</h3>
                  <p style={{color: BRAND.muted, fontSize: 15, lineHeight: 1.6, margin: 0}}>{w.text}</p>
                </div>
              </div>
            ))}
          </div>
          <div style={{textAlign: 'center', padding: '40px 0 8px'}}>
            <Link to='/auth/registration' className='ccp-cta' style={{display: 'inline-block', textDecoration: 'none', fontWeight: 700, fontSize: 16, color: '#fff', background: BRAND.green, borderRadius: 12, padding: '14px 30px'}}>
              Join the pad
            </Link>
          </div>
        </Container>
      </section>
    </div>
  )
}

export {AboutPage}
